var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollViewBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 64,
    viewBox: "0 0 84 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 56,
    height: 64,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 28C42.5523 28 43 27.5523 43 27L43 15.83L47.88 20.71C48.2717 21.1017 48.9072 21.1006 49.2975 20.7075C49.6859 20.3164 49.6848 19.6848 49.295 19.295L43.4142 13.4142C42.6332 12.6332 41.3668 12.6332 40.5858 13.4142L34.7053 19.2947C34.3158 19.6842 34.3158 20.3158 34.7053 20.7053C35.0946 21.0946 35.7257 21.0949 36.1153 20.7059L41 15.83L41 27C41 27.5523 41.4477 28 42 28Z",
    fill: "#212529",
    stroke: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 36C42.5523 36 43 36.4477 43 37L43 48.17L47.88 43.29C48.2717 42.8983 48.9072 42.8994 49.2975 43.2925C49.6859 43.6836 49.6848 44.3152 49.295 44.705L43.4142 50.5858C42.6332 51.3668 41.3668 51.3668 40.5858 50.5858L34.7053 44.7053C34.3158 44.3158 34.3158 43.6842 34.7053 43.2947C35.0946 42.9054 35.7257 42.9051 36.1153 43.2941L41 48.17L41 37C41 36.4477 41.4477 36 42 36Z",
    fill: "#212529",
    stroke: "#212529"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollViewBig);
export default __webpack_public_path__ + "static/media/scroll-view-big.56638f02.svg";
export { ForwardRef as ReactComponent };